var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['map-palette-colors', _vm.isCurrent ? 'current' : '']},_vm._l((_vm.colors),function(color,i){return _c('div',{key:color + i,staticClass:"map-palette-colors__item",style:(`background-color: ${color}`)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }